import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = {
    message: {
      /* 用户信息采集 */
      'tips':'tips',
      'name':'name',
      'tel':'tel',
      'email':'email',
      'company':'company',
      'seriesofinterest':'series of interest',
      'incorrectformat!':'incorrect format!',
      'pleaseenter':'please enter',
      'submit':'submit',
      'reset':'reset',
      /* ——————————— */
      'title_01' : 'Motor Selection',
      'title_02' : 'Load Selection',
      'title_03' : 'Application Selection',
      'title_04' : 'Reducer Selection',
      'title_05' : 'Moment of Inertia Calculator',
      'homepage' : 'Homepage',
      'product'  : 'Product',
      'motor' : 'Selected motor',
      'Selectionofparameters' : 'Reducer',
      'ratio' : 'Selected deceleration ratio',
      'size' : 'Selected size',
      'complete' : 'complete',
      'motorSelection': 'motor selection',
      'Manufacturers': 'Manufacturers',
      'Type': 'Motor Type',
      'Return':'Return',
      'Next': 'Next',
      'reducerList':'Retarder Details Table',
      'reducerSeries':'Reducer Series',
      'reductionRatio':'Reduction Ratio',
      'manufacturer':'facturer',
      'model':'model',
      'series':'series',
      'selectSizeInfo' : 'Please select reducer size',
      'Information' : 'Information',
      'DecelerationDimensionDetails' : 'Deceleration Dimension Details',
      'ReducerModel' : 'Reducer Model',
      'Info' : 'Refer to physical objects according to appearance.',
      'Dso':'Download specifications&outlines',
      'DecelerationDimensionDetails':'Deceleration Dimension Details',
      'clickDownload':'Download',
      'InstallMotor':'Install Motor',
      'motorSpecifications':'Motor Specifications',
      'notes':'Notes',
      'returnIndex':'toHomePage',
      'selectedSeries':'Series',
      'loadCondition':'load Condition',
      'reducerSize':'reducer Size',
      'selectMotor':'select Motor',
      'reducer':'Reducer Series:',
      'info01':'Please choose the deceleration ratio.',
      'info02':'Please select the number of operating modes (n)',
      'info03':'Please enter load conditions',
      'info04':'Please enter the impact coefficient KA',
      'info05':'Technical Drawings',
      'info06':'Please select the reducer series',
      'info07':'Reducer Model-Series-Motor Size',
      'info08':'1. If positive and negative rotation quickly and frequently,and the rotational intertia is big, please choose the low backlash products refer to the condition factor.',
      'info09':'2. When the output speed of the gearbox is lower than 1 rpm, the internal grease will be poorly lubricated. Please consult us.',
      'info10':'3. The motor will shake when the length ratio of the motor to the gearbox(size more than 142) is above 2, especially the gears and pulleys. Please strengthen the structure.',
      'info11':'4. The selection result just for reference. Please contact us freely if you have any doubt about the correctness of the result.',
      'info12':'If no reducer is available, please modify the torque equivalent',
      'info13':'(This method is a rough estimate, please use process 2 or 3 to calculate accurately)',
      'title01':'Output torque (s)',
      'title02':'Output speed (r/min)',
      'title03':'Action time (s)',
      'title04':'Radial load (N)',
      'title05':'Axial load (N)',
      'title06':'Radial distance (mm)',
      'title07':'Axial distance (mm)',
      'Reducersystem':'Reducer system:',
      'title08':'motor manufacturer',
      'title09':'motor model',
      'title10':'Series Name',
      'title11':'Deceleration ratio',
      'note01':'1. If the motor manufacturer you use does not exist in the list, please ask our company',
      'note02':'2. When the motor you use does not exist in the list, please inquire about our company',
      'note03':'3. Please confirm the efficiency characteristics of the reducer before making the selection of the motor',
      'ApplicationSelection' : 'Application Selection',
      'AppLoadconditions':'AppLoad conditions',
      'ReducerLoadconditions':'Reducer Load conditions',
      'Operationmode':'Operation mode',
      'ReducerModelTable':'Reducer Model Table',
      'SelectedSeriesName':'Series Name',
      'SelectedSpecifications':'Specifications',
      'SelectedSeries':'Series',
      'Selecteddecelerationratio':'deceleration ratio',
      'SelectMotorSize':'Motor Size',
      'WhetherWithAKey':'Whether A Key',
      'CalculationInertia':'Calculation of moment of inertia',
      'TypeSelection':'Type Selection',
      'ParameterInput':'Parameter Input',
      'ComputationalResults':'Computational Results',
      'DensityReference':'Density reference',
      'Compute':'Compute',
      'CylinderVertical':'Cylinder - Vertical',
      'Square':'Square',
      'Cylinder Parallel':'Cylinder - Parallel',
      'BallScrew':'Ball Screw',
      'spherical':'spherical',
      'cake':'cake',
      'arbitraryObject':'arbitrary object',
      'compute1':'inner diameter',
      'compute2':'outer diameter',
      'compute3':'Length',
      'compute4':'density',
      'compute5':'The distance between the center of gravity and the axis of rotation',
      'compute6':'mass of objects',
      'compute7':'Inertia of objects',
      'compute8':'Width',
      'compute9':'height',
      'compute10':'Guide',
      'compute11':'Diameter',
      'compute12':'Thickness',
      'compute13':'inertia',
      'compute14':'Quality',
      'returnApp':'returnApp',
      'GearboxModel':'Gearbox Model',
      'Judge':'Judge',
      'Stage':'Stage',
      'Note':'Note',
      'Life':'Life(h)',
      'NG':'NG',
      'OK':'OK',
      'complete_title_01':'Ratio',
      'complete_title_02':'Torsional Rigidity',
      'complete_title_03':'Emergency Stop Torque',
      'complete_title_04':'Max Axial Force',
      'complete_title_05':'Max Ridial Force',
      'complete_title_06':'Max Speed',
      'complete_title_07':'Nominal Speed',
      'complete_title_08':'Rotational Inertia',
      'complete_title_09':'Nominal Output Torque',
      'complete_title_10':'Average Lifetime',
      'complete_title_11':'Full Loading Efficiency',
      'complete_title_12':'电机厂商',
      'complete_title_13':'电机型号',
      'complete_title_14':'功率',
      'complete_title_15':'Rotational Inertia',
      'complete_title_16':'Nominal Speed',
      'complete_title_17':'最高转速',
      'complete_title_18':'峰值扭矩',
      'complete_title_19':'轴直径C3',
      'complete_title_20':'轴到面长C4',
      'complete_title_21':'安装止口C5',
      'complete_title_22':'止口长C6',
      'complete_title_23':'最小分布圆C1-1',
      'complete_title_21':'最大分布圆C1-2',
      'complete_title_22':'螺纹C2',
      'complete_title_23':'安装方式',
      'RotaryTable':'Rotary Table',
      'ConveyorBelt':'Conveyor Belt',
      'PinionandRack':'Pinionand Rack',
      'LiftingandLoweringDevice':'Lifting and Lowering Device',
      'AGVcar':'AGV car',
      'SrewDrive':'Srew Drive',
      'GearDrive':'Gear Drive',
      'SynchronousBeltDrive':'Synchronous Belt Drive',
      'zhuantai_1':'Rotary table',
      'zhuantai_2':'Table radius',
      'zhuantai_3':'Table weight',
      'zhuantai_4':'Load radius',
      'zhuantai_5':'Load weight',
      'zhuantai_6':'Load distance',
      'zhuantai_7':'Connecting method',
      'zhuantai_8':'Direct coupling',
      'zhuantai_9':'Couping',
      'zhuantai_10':'Bearing diameter',
      'zhuantai_11':'Friction coefficient',
      'zhuantai_12':'Accelerating time',
      'zhuantai_13':'Uniform speed time',
      'zhuantai_14':'Decelerating time',
      'zhuantai_15':'Stop time',
      'zhuantai_16':'Speed',
      'chuansongdai_1':'Conveyor belt',
      'chuansongdai_2':'Delivery weight',
      'chuansongdai_3':'Belt diameter',
      'chuansongdai_4':'Inclination angle',
      'chuansongdai_5':'Belt tension',
      'chuansongdai_6':'Friction torque',
      'chitiao_1':'Pinion and rack',
      'chitiao_2':'Table weight',
      'chitiao_3':'Inclination angle',
      'chitiao_4':'Object weight',
      'chitiao_5':'Pinion diameter',
      'chitiao_6':'Number of gears',
      'chitiao_7':'Helical angle',
      'chitiao_8':'Table Friction coefficient',
      'shengjiang_1':'Lifting and lowering device',
      'shengjiang_2':'Object weight',
      'shengjiang_3':'Balance weight',
      'shengjiang_4':'Sprocket weight',
      'shengjiang_5':'Total rotational inertia',
      'shengjiang_6':'Friction torque',
      'shengjiang_7':'Connecting method',
      'shengjiang_8':'Direct coupling',
      'shengjiang_9':'Sprocket',
      'shengjiang_10':'Reducer sprocket pitch circle',
      'shengjiang_11':'Lifting sprocket pitch circle',
      'shengjiang_12':'Sprocket pitch circle',
      'agv_1':'AGV car',
      'agv_2':'Cargo weight',
      'agv_3':'Wheel diameter',
      'agv_4':'Single wheel weight',
      'agv_5':'Number of wheel',
      'agv_6':'Gradient',
      'agv_7':'Wheel Friction coefficient',
      'agv_8':'Method of supporting',
      'agv_9':'Wheel supporting',
      'agv_10':'Direct connect',
      'sigan_1':'Screw drive',
      'sigan_2':'Thread distance',
      'sigan_3':'Inclination angle',
      'sigan_4':'Weight',
      'sigan_5':'Friction coefficient',
      'sigan_6':'Rotational inertia',
      'chuandong_1':'Gear drive',
      'chuandong_2':'Gear 1 diameter',
      'chuandong_3':'Gear 2 diameter',
      'chuandong_4':'Gear 1 rotary inertia',
      'chuandong_5':'Gear 2 total rotary inertia',
      'chuandong_6':'Helical angle',
      'chuandong_7':'Gear 1 torque',
      'tongbudai_1':'Synchronous belt drive',
      'tongbudai_2':'wheel diameter 1',
      'tongbudai_3':'wheel diameter 2',
      'tongbudai_4':'Rotary inertia 1',
      'tongbudai_5':'Rotation 2 total rotary inertia',
      'tongbudai_6':'Tension',
      'tongbudai_7':'Torque 1',
      'ReducerList_1':'Stage',
      'ReducerList_2':'Ratio',
      'ReducerList_3':'Rated output torque(Nm)',
      'ReducerList_4':'Emergency Stop Torque',
      'ReducerList_5':'Max Ridial Force(N)',
      'ReducerList_6':'Max Axial Force(N)',
      'ReducerList_7':'Full Load Efficiency(%)',
      'ReducerList_8':'Average Lifetime(h)',
      'ReducerList_9':'Rotational Inertia(kgc㎡)',
      'ReducerList_10':'Single Backlash(arcmin)',
      'ReducerList_11':'Torsional Rigidity(Nm/arcmin)',
      'ReducerList_12':'Nosie(dB(A))',
      'ReducerList_13':'Max Input Speed (Nm/arcmin)',
      'ReducerList_14':'Nominal Input Speed(min-1)',
      'ReducerList_15':'Weight(kg)',
      'ReducerList_16':'Torsional Rigidity(Nm/arcmin)',
      'ReducerList_17':'2 Nominal Output Torque',
      'ReducerList_18':'3 Nominal Output Torque',
      'ReducerList_19':'Download',
      'ReducerList_20':'K Series Reducer',
      'ReducerList_21':'S Series Reducer',
      'ReducerList_22':'Others Series Reducer',
      'ReducerList_23':'KT Series Reducer',
      'finish_1':'Ratio',
      'finish_2':'Torsional Rigidity',
      'finish_3':'Fault Stop Torque',
      'finish_4':'Max Axial Force',
      'finish_5':'Max Ridial Force',
      'finish_6':'Max Speed',
      'finish_7':'Rated Speed',
      'finish_8':'Rotational Inertia',
      'finish_9':'Nominal Output Torque',
      'finish_10':'Average Lifetime',
      'finish_11':'Full Load Efficiency',
      'finish_12':'Motor Brand',
      'finish_13':'Motor Size',
      'finish_14':'Nominal Output Torque',
      'finish_15':'power',
      'finish_16':'Rotational Inertia',
      'finish_17':'Nominal Speed',
      'finish_18':'Max Speed',
      'finish_19':'Peak Torque',
      'finish_20':'Shaft Diameter C3',
      'finish_21':'Axis To Surface Length C4',
      'finish_22':'Mounting Spigot C5',
      'finish_23':'Spigot Depth C6',
      'finish_24':'Min bolthole circle C1-1',
      'finish_25':'Max bolthole circle C1-1',
      'finish_26':'Reducer Thread',
      'finish_27':'Mounting Method',
      'finish_28':'Max Input Speed',
      'finish_29':'Average Input Speed',
      'finish_30':'Max Output Torque',
      'finish_31':'Average Output Torque',
      'finish_32':'Average Radial Force',
      'finish_33':'Max Radial Force',
      'finish_34':'Average Axial Force',
      'finish_35':'Max Axial Force',
      'ie_text':'Your browser version is too low. Please install Chrome Browser for access.',
      'ie_download':'download',
      'CycleNumberHour':'Cycle number/hour',
      'systemName':'Gearbox Selection System KDP',
      'fileDownLoad':'Manual download'
    },
    ...enLocale
}
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js